__webpack_require__.p = "https://assets.yanolja.com/platform-site/prod/ddd4117fad8386e4e5d798cf1b6070237c85b7b0/_next/";